export default "<button\n  [type]=\"type\"\n  [class]=\"buttonClass\"\n  [disabled]=\"disabled\"\n  (click)=\"onClick($event)\">\n  {{ label }}\n</button>\n"